var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPoster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    rx: 5,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 639.5,
    cy: 359.5,
    r: 104.5,
    fill: "#8E8E8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700 359.5L609.25 307.105V411.895L700 359.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPoster);
export default __webpack_public_path__ + "static/media/videoPoster.d7db2a3839d987547054c6470d3ce9e4.svg";
export { ForwardRef as ReactComponent };